<div class="white-background">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        <div class="p-4">
            <img class="" ngSrc="/assets/img/logo.png" alt="LOGO" width="340" height="68" />
        </div>

        <div class="tagline">
            <h5 class="text-weight-bold" style="color: #3BA378">
                World’s Most Reliable Certification Manager for
                <i>Competitive</i> Professionals
            </h5>
        </div>
    </div>
    <div class="text-center">
        <img class="mt-2 mb-5" ngSrc="/assets/img/Welcome-to-Your-New-Wallet!.png" alt="" width="374" height="89" />
    </div>
    <div class="container white-background">
        <div class="row mt-5">
            <div class="col-md-12 text-center pt-5">
                <h5 *ngIf="!success" style="color: #000; font-size: 30px">{{message}}</h5>
                <div *ngIf="success" class=" pt-5">
                    <h5 style="color: #000; font-size: 30px">Thank you for verifying your email! 🎉</h5>
                    <h5 style="color: #000; font-size: 30px">Your account is now fully set up, and you’re all set to explore everything we have to offer. If you have any questions or need assistance, feel free to reach out to us anytime.</h5>
                    <h5 style="color: #000; font-size: 30px">We’re excited to have you on board!</h5>
                </div>
            </div>
        </div>
    </div>
</div>
